const CircleIcon = ({
  label,
  backgroundColor,
  color,
  size,
  fontSize,
}: {
  label: string;
  backgroundColor: string;
  color: string;
  size: number;
  fontSize?: number;
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: size,
        minWidth: size,
        borderRadius: size / 2,
        backgroundColor,
        color,
        fontSize,
      }}
    >
      {label}
    </div>
  );
};

export default CircleIcon;
